module.exports = __webpack_public_path__ + "img/stage-sell-invoice.1213466c.png";